import React from "react";
import TablePagination from "@material-ui/core/TablePagination";

const ListPagination = ({
	total = 0,
	page = 1,
	limit = 50,
	onPageChange,
	onLimitChange,
	rowsPerPageOptions = [25, 50, 100],
}) => {
	if (total === 0) {
		return null;
	}

	return (
		<TablePagination
			component="div"
			count={total}
			page={Math.max(0, page - 1)}
			onPageChange={(event, newPage) => onPageChange(newPage + 1)}
			rowsPerPage={limit}
			onRowsPerPageChange={(event) =>
				onLimitChange(parseInt(event.target.value, 10))
			}
			rowsPerPageOptions={rowsPerPageOptions}
		/>
	);
};

export default ListPagination;
